type MediaComponentProps = {
  url: string;
  className?: string;
  sysId?: any;
  imageAltText?: any;
};
export const MediaComponent: React.FC<MediaComponentProps> = ({
  url,
  sysId,
  imageAltText,
  className,
}) => {
  const isVideo = (url: string): boolean => {
    const videoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.mkv'];
    return videoExtensions.some(ext => url.endsWith(ext));
  };
  return (
    <div data-testid="media-component">
      {url && isVideo(url) ? (
        <video src={url} autoPlay loop muted />
      ) : (
        <img
          src={url}
          className={className}
          loading="lazy"
          alt={imageAltText}
          data-contentful-entry-id={sysId}
        />
      )}
    </div>
  );
};
